import React from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Container } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

    const ExitApprovals = () => {
        return (
            <>
                <div className="page-content">
                    <MetaTags>
                    <title>Exit Approvals | Bridge</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title="Human Resource Management" breadcrumbItem="Disciplinary and Grievances" />
                        
                           

                    </Container>
                </div>
            </>
        );
    }

export default ExitApprovals;